var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppbarDropdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.47354 0.473566C9.41156 0.41108 9.33783 0.361484 9.25659 0.327638C9.17535 0.293792 9.08821 0.276367 9.0002 0.276367C8.9122 0.276367 8.82506 0.293792 8.74382 0.327638C8.66258 0.361484 8.58885 0.41108 8.52687 0.473566L5.47354 3.52689C5.41156 3.58938 5.33783 3.63897 5.25659 3.67282C5.17535 3.70667 5.08821 3.72409 5.0002 3.72409C4.9122 3.72409 4.82506 3.70667 4.74382 3.67282C4.66258 3.63897 4.58884 3.58938 4.52687 3.52689L1.47354 0.473566C1.41156 0.41108 1.33783 0.361484 1.25659 0.327638C1.17535 0.293792 1.08821 0.276367 1.0002 0.276367C0.912195 0.276367 0.825058 0.293792 0.743818 0.327638C0.662579 0.361484 0.588845 0.41108 0.526869 0.473566C0.402702 0.598474 0.333008 0.767441 0.333008 0.943565C0.333008 1.11969 0.402702 1.28866 0.526869 1.41356L3.58687 4.47356C3.96187 4.84809 4.4702 5.05846 5.0002 5.05846C5.5302 5.05846 6.03854 4.84809 6.41354 4.47356L9.47354 1.41356C9.5977 1.28866 9.6674 1.11969 9.6674 0.943565C9.6674 0.767441 9.5977 0.598474 9.47354 0.473566Z",
    fill: "#6D6D6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppbarDropdownIcon);
export default __webpack_public_path__ + "static/media/appbar-dropdown-icon.6b2f45882fd43f331be3042d4f09376a.svg";
export { ForwardRef as ReactComponent };